import { render } from "./Collect.vue?vue&type=template&id=043f1f34"
import script from "./Collect.vue?vue&type=script&lang=js"
export * from "./Collect.vue?vue&type=script&lang=js"

import "./Collect.vue?vue&type=style&index=0&id=043f1f34&lang=less"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__